import { Configuration, FrontendApi } from "@ory/client"

export const kratosBasePath = process.env.REACT_APP_KRATOS_PUBLIC_URL || "http://localhost:4433"

export const kratos = new FrontendApi(
  new Configuration({
    basePath: kratosBasePath,
    baseOptions: {
      withCredentials: true,
    },
  }),
)
